import { HighchartsReactProps } from 'highcharts-react-official'
import { cloneDeep, merge } from 'lodash'

const getChartOptions = (
  options: HighchartsReactProps,
  newOptions: HighchartsReactProps,
  overrides?: HighchartsReactProps,
) => {
  const defaultOptionsClone = cloneDeep(options)
  const newOptionsClone = cloneDeep(newOptions)

  const mergedOptions = merge(defaultOptionsClone, newOptionsClone)
  if (overrides) {
    merge(mergedOptions, overrides)
  }

  return mergedOptions
}

export default getChartOptions
